/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivClearanceApprovalRequestControllerAcceptParamsGen,
  MrfiktivClearanceApprovalRequestControllerGetParamsGen,
  MrfiktivClearanceApprovalRequestControllerRejectParamsGen,
  MrfiktivClearanceApprovalViewModelGen,
  MrfiktivCreateRequestStatusHistoryElementDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ClearanceApprovalRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags clearance-approval-request
   * @name ClearanceApprovalRequestControllerGet
   * @summary (SCT) Get a Clearance Approval via Shared Content Token
   * @request GET:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}/request
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The found clearance approval
   */
  clearanceApprovalRequestControllerGet = (
    { partnerId, clearanceApprovalId, ...query }: MrfiktivClearanceApprovalRequestControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}/request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval-request
   * @name ClearanceApprovalRequestControllerAccept
   * @summary (SCT) Respond to a clearance approval request (e.g. submit reply with document)
   * @request PATCH:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}/request/accept
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The updated clearance approval
   */
  clearanceApprovalRequestControllerAccept = (
    { partnerId, clearanceApprovalId, ...query }: MrfiktivClearanceApprovalRequestControllerAcceptParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}/request/accept`,
      method: "PATCH",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval-request
   * @name ClearanceApprovalRequestControllerReject
   * @summary (SCT) Perform an action on a clearance approval (e.g., reject, request more data)
   * @request PATCH:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}/request/reject
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The updated clearance approval
   */
  clearanceApprovalRequestControllerReject = (
    { partnerId, clearanceApprovalId, ...query }: MrfiktivClearanceApprovalRequestControllerRejectParamsGen,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}/request/reject`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
